// extracted by mini-css-extract-plugin
export default {"header":"Heading_header__XB4H7","tooltipIcon":"Heading_tooltipIcon__qPERK"};